export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";